import { useState } from 'react';
import { useNavigate } from 'react-router';

import Input from '@cartwhl/ui/atoms/Input';
import GoButton from '@cartwhl/ui/input/GoButton';

import { authStore } from 'stores/global';

import AuthPageLayout from './AuthPageLayout';

export default function PasswordResetPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const resetToken =
    new URLSearchParams(window.location.search).get('token') || '';

  return (
    <AuthPageLayout title="Reset password">
      <form
        className="grid grid-cols-2 gap-x-4 gap-y-6 pb-10"
        onSubmit={async (e) => {
          e.preventDefault();
          const password = e.currentTarget.password.value;
          setLoading(true);
          await authStore.resetPassword(password, resetToken);
          setLoading(false);
          navigate('/login?redirectTo=studio');
        }}
      >
        <Input
          label="Your new password"
          name="password"
          type="password"
          placeholder="Password"
          className="col-span-2"
        />
        <GoButton className="col-span-2 mt-8" loading={loading} type="submit">
          Reset password
        </GoButton>
      </form>
    </AuthPageLayout>
  );
}
